import { useCallback, useEffect, useState } from "react";
import { Genre, useMusicApi } from "../api/useMusicApi";

export function useGenres() {
  const { getGenres } = useMusicApi();
  const [genres, setGenresForSelectValues] = useState<Genre[]>([]);

  useEffect(() => {
    void fetchGenres();
  }, []);

  const fetchGenres = useCallback(async () => {
    try {
      const res = await getGenres();
      setGenresForSelectValues(res.results);
    } catch (e) {}
  }, []);

  return {
    genres,
  };
}
